module.exports = __webpack_public_path__ + "static/media/invitedFriends_1000.fe26f11a.png";